import DarwinTypography from 'components/darwin-ui/Typography';
import styles from './index.module.css';
import { DarwinFlex } from '../Flex';
import Icon, { IconName } from '../Icon';

export enum StatusChipColors {
  green = 'green',
  red = 'red',
  yellow = 'yellow',
  blue = 'blue',
}

export enum StatusChipIcon {
  endFlow = 'end-of-flow',
}

interface StatusChipProps {
  color?: StatusChipColors;
  label?: string;
  icon?: IconName;
}

export const StatusChip = ({
  color = StatusChipColors.green,
  label,
  icon,
}: StatusChipProps) => {
  const chipClass = `${styles.statusChip} ${color ? styles[color] : ''}`;

  return (
    <DarwinFlex>
      <DarwinTypography.Text className={chipClass}>
        {icon && <Icon name={icon} size="sm" style={{ marginRight: '4px' }} />}
        {label}
      </DarwinTypography.Text>
    </DarwinFlex>
  );
};
